// Global configuration

// The url to the REST API. Must end with a slash.
//export var apiBaseUrl = "http://localhost/api/";
export var apiBaseUrl = "http://www.aventyrskursen.se/api/";
